var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useReducer } from 'react';
import defaultState from './defaultState';
import featureFlagReducer from './reducer';
// this export should only be used for testing and FeatureFlagProvider is for actual use
export var FeatureFlagContext = createContext(undefined);
var FeatureFlagProvider = function (_a) {
    var children = _a.children;
    var _b = useReducer(featureFlagReducer, defaultState), state = _b[0], dispatch = _b[1];
    return (_jsx(FeatureFlagContext.Provider, __assign({ value: useMemo(function () { return ({ state: state, dispatch: dispatch }); }, [state]) }, { children: children })));
};
function useFeatureFlag() {
    var context = useContext(FeatureFlagContext);
    if (context === undefined) {
        throw new Error('useFeatureFlag must be used within a FeatureFlagProvider');
    }
    return context;
}
export { FeatureFlagProvider, useFeatureFlag };
